import { jsxs, jsx } from 'react/jsx-runtime';
import { InnerContainer } from './styled.js';
import { ReactComponent as ForwardRef } from '../../../../../assets/icons/ArrowDownSmall.svg.js';
import 'react';
import { ReactComponent as ForwardRef$1 } from '../../../../../assets/icons/ArrowUpSmall.svg.js';
import Hint from '../../../../Hint/Hint.js';

const Header = ({ column, disabled, sortEnabled, isDragging, rtl, filterEnabled, isCheckboxColumn, children, }) => {
    const SortIcon = !column.isSortedDesc ? ForwardRef : ForwardRef$1;
    let title = null;
    if (!disabled) {
        if (sortEnabled && !isDragging && typeof children === 'string') {
            title = `Sort by ${children}${column.isSorted && !isDragging ? (!column.isSortedDesc ? '\n(Ascending Order)' : '\n(Descending Order)') : ''}`;
        }
        else {
            title = !isCheckboxColumn ? 'Sort by Id' : null;
        }
    }
    const rowContainer = (jsxs("div", Object.assign({ style: { display: 'flex', width: '100%', justifyContent: 'space-between' } }, { children: [jsx(InnerContainer, Object.assign({ rtl: rtl }, { children: jsx("div", { children: children }) })), (filterEnabled || sortEnabled) && (jsxs("div", Object.assign({ style: { display: 'flex' } }, { children: [filterEnabled ? column.render('Filter') : null, sortEnabled && (jsx(SortIcon, { className: "sort-icon", style: {
                            visibility: !disabled && !isCheckboxColumn ? 'visible' : 'hidden',
                        } }))] })))] })));
    return title ? (jsx(Hint, Object.assign({ placement: "bottom-end", title: title, "data-testid": "row-hint" }, { children: rowContainer }))) : (rowContainer);
};

export { Header as default };
//# sourceMappingURL=Header.js.map
